/* ============================================================
   7 @ 7 — AMC Furniture JavaScript
   File: assets/7at7.js
   Add to theme.liquid: {{ '7at7.js' | asset_url | script_tag }}
   ============================================================ */

(function () {
  'use strict';
// function updateCountdown(){

// const now = new Date();

// const today7pm = new Date();
// today7pm.setHours(19,0,0,0);

// const tomorrow7pm = new Date(today7pm);
// tomorrow7pm.setDate(tomorrow7pm.getDate() + 1);

// let diff;

// if(now < today7pm){

// // BEFORE 7PM
// diff = today7pm - now;

// document.querySelector('.at7-products-wrapper')?.classList.remove('at7-hidden');
// document.querySelector('.at7-deals-ended')?.style.setProperty("display","none");

// }
// else{

// // AFTER 7PM
// diff = tomorrow7pm - now;

// document.querySelector('.at7-products-wrapper')?.classList.add('at7-hidden');
// document.querySelector('.at7-deals-ended')?.style.setProperty("display","block");

// }


// const h = Math.floor(diff / 3600000);
// const m = Math.floor((diff % 3600000) / 60000);
// const s = Math.floor((diff % 60000) / 1000);

// document.querySelectorAll('.at7-hours').forEach(el=>{
// el.textContent = String(h).padStart(2,'0');
// });

// document.querySelectorAll('.at7-minutes').forEach(el=>{
// el.textContent = String(m).padStart(2,'0');
// });

// document.querySelectorAll('.at7-seconds').forEach(el=>{
// el.textContent = String(s).padStart(2,'0');
// });

// }

// (function(){

// const now = new Date();

// const drop = new Date();
// drop.setHours(19,0,0,0);

// const diff = drop - now;

// if(diff > 0){

// setTimeout(function(){

// location.reload();

// }, diff);

// }

// })();
//   // Initialise on any page that has a countdown
//   if (document.querySelector('.at7-countdown__timer')) {
//     updateCountdown();
//     setInterval(updateCountdown, 1000);
//   }
function updateCountdown(){

const now = new Date();

const today7pm = new Date();
today7pm.setHours(19,0,0,0);

const tomorrow7pm = new Date(today7pm);
tomorrow7pm.setDate(tomorrow7pm.getDate() + 1);

let diff;

// BEFORE 7PM
if(now < today7pm){

diff = today7pm - now;

// products visible
document.querySelector('.at7-products-wrapper')?.classList.remove('at7-hidden');

// deals ended hidden
document.querySelector('.at7-deals-ended')?.style.setProperty("display","none");

}

// AFTER 7PM
else{

diff = tomorrow7pm - now;

// products visible (collection already swapped via Liquid)
document.querySelector('.at7-products-wrapper')?.classList.remove('at7-hidden');

// deals ended hidden
document.querySelector('.at7-deals-ended')?.style.setProperty("display","none");

}

const h = Math.floor(diff / 3600000);
const m = Math.floor((diff % 3600000) / 60000);
const s = Math.floor((diff % 60000) / 1000);

document.querySelectorAll('.at7-hours').forEach(el=>{
el.textContent = String(h).padStart(2,'0');
});

document.querySelectorAll('.at7-minutes').forEach(el=>{
el.textContent = String(m).padStart(2,'0');
});

document.querySelectorAll('.at7-seconds').forEach(el=>{
el.textContent = String(s).padStart(2,'0');
});

}


// AUTO RELOAD EXACTLY AT 7PM
(function(){

const now = new Date();

const drop = new Date();
drop.setHours(19,0,0,0);

let diff = drop - now;

// if already past 7pm schedule tomorrow
if(diff <= 0){
drop.setDate(drop.getDate() + 1);
diff = drop - now;
}

setTimeout(function(){
location.reload();
}, diff);

})();


// START TIMER
if (document.querySelector('.at7-countdown__timer')) {
updateCountdown();
setInterval(updateCountdown, 1000);
}
  // ── NOTIFY ME MODAL ──────────────────────────────────────────
  function openAt7Modal() {
    var modal = document.getElementById('at7-notify-modal');
    if (modal) {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeAt7Modal() {
    var modal = document.getElementById('at7-notify-modal');
    if (modal) {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  // Open: all notify buttons
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-at7-notify]')) {
      e.preventDefault();
      openAt7Modal();
    }
  });

  // Close: X button or backdrop click
  document.addEventListener('click', function(e) {
    if (e.target.matches('#at7-notify-modal') || e.target.closest('[data-at7-close]')) {
      closeAt7Modal();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAt7Modal();
  });

  // ── FORM SUBMIT ──────────────────────────────────────────────
  // Hooks into Klaviyo's JS API if present, or posts to a custom endpoint.
  // Replace KLAVIYO_LIST_ID below with your actual Klaviyo list ID.
  var KLAVIYO_LIST_ID = 'YOUR_LIST_ID'; // ← Update this

  var form = document.getElementById('at7-notify-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var firstName = form.querySelector('[name="first_name"]').value.trim();
      var email     = form.querySelector('[name="email"]').value.trim();
      var phone     = form.querySelector('[name="phone"]').value.trim();

      if (!email) return;

      var btn = form.querySelector('.at7-modal__submit');
      btn.textContent = 'Signing up...';
      btn.disabled = true;

      // Klaviyo Subscribe API
      var payload = {
        token: KLAVIYO_LIST_ID,
        properties: {
          $email:       email,
          $first_name:  firstName,
          $phone_number: phone,
          source:       '7at7-notify-me'
        }
      };

      fetch('https://a.klaviyo.com/api/identify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function() {
        form.innerHTML = [
          '<div style="text-align:center;padding:24px 0">',
          '<div style="font-size:48px;margin-bottom:16px">✅</div>',
          '<h3 style="font-size:22px;font-weight:800;margin-bottom:8px">You\'re on the list!</h3>',
          '<p style="color:#888;font-size:14px">We\'ll text & email you before 7pm every night.</p>',
          '</div>'
        ].join('');
      })
      .catch(function() {
        btn.textContent = '✅ Sign Me Up — Notify Me!';
        btn.disabled = false;
        alert('Something went wrong. Please try again.');
      });
    });
  }

})();

